import verge from 'verge'
import {dispatch} from '../store'

import setViewportDimensions from '../actions/set_viewport_dimensions'

const onResize = () => {
  const width = verge.viewportW()
  const height = verge.viewportH()

  dispatch(setViewportDimensions(width, height))
}

export default () => {
  onResize()

  window.addEventListener('resize', onResize)
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/watchers/viewport_resize.js
 **/